import { render } from "./ConversationChatBot.vue?vue&type=template&id=01e6edb6&scoped=true"
import script from "./ConversationChatBot.vue?vue&type=script&lang=js"
export * from "./ConversationChatBot.vue?vue&type=script&lang=js"

import "./ConversationChatBot.vue?vue&type=style&index=0&id=01e6edb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e6edb6"]])

export default __exports__